import useTools from "@/use/Tools.js";
import useSharedData from "@/use/SharedData.js";
import {useSecurityStore} from "@/stores/Security";
import useSharedSelectData from "@/use/SharedSelectData";
import moment from "moment";
import axios from "axios";
// import {useSettingStore} from "@/stores/Setting";

export default function useSharedMethod() {

    const {$moment, $router, $i18n} = useTools();
    // const settingStore = useSettingStore();


    const {itemColor, selectedOne} = useSharedData();

    function rowColor(item) {
        if (item.id === selectedOne.value.id) {
            return itemColor.value;
        }
    }

    function itemClick(item) {
        selectedOne.value = item;
    }

    function getBack() {
        $router.go(-1);
    }


    function priceFormat(value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

    function formatedMonth(date) {
        return date ? $moment(date).format("MM-YYYY") : "";
    }

    function formatedDate(date) {
        return date ? $moment(date).format("DD-MM-YYYY") : "";
    }

    function formatedDateTime(date) {
        return date ? $moment(date).format("DD-MM-YYYY HH:mm") : "";
    }

    function formatedTime(time) {
        if (time) {
            let momentTime = moment(time, "HH:mm:ss");
            return momentTime.format("HH:mm");
        } else {
            return "..:..";
        }
    }

    function logout() {
        window.localStorage.clear();
        securityStore.setAccessToken(null);
        $router.push({name: "login"});
    }

    function getDialogToolbar(actions) {
        const toolbarConfig = {
            addAction: {color: 'teal', title: 'common.add', action: 'add'},
            updateAction: {color: 'orange', title: 'common.edit', action: 'edit'},
            deleteAction: {color: 'red', title: 'common.delete', action: 'delete'},
            viewAction: {color: 'blue', title: 'common.view', action: 'view'},
            renewAction: {color: 'cyan', title: 'common.renew', action: 'renew'},
            archiveAction: {color: 'purple', title: 'common.archive', action: 'archive'},
            unarchiveAction: {color: 'purple', title: 'common.unarchive', action: 'unarchive'},
            activateAction: {color: 'blue', title: 'common.activate', action: 'activate'},
            printAction: {color: 'blue-grey', title: 'common.print', action: 'print'},
            launchAction: {color: 'cyan', title: 'common.launch', action: 'launch'},
            lockAction: {color: 'grey darken-2', title: 'common.lock', action: 'lock'},
            unlockAction: {color: 'grey darken-2', title: 'common.unlock', action: 'unlock'}
        };

        const actionOrder = [
            'addAction',
            'updateAction',
            'deleteAction',
            'viewAction',
            'renewAction',
            'archiveAction',
            'unarchiveAction',
            'activateAction',
            'printAction',
            'launchAction',
            'lockAction',
            'unlockAction'
        ];

        for (const actionKey of actionOrder) {
            if (actions[actionKey]) {
                return toolbarConfig[actionKey];
            }
        }

        return null; // or a default config if needed
    }

    const securityStore = useSecurityStore();

    function getClaimParamsByType(type, inranet) {
        let rootPath;
        let api;
        let title;
        let saveOperation;
        let updateOperation;
        let deleteOperation;
        switch (type) {
            case 'CLAIM':
                rootPath = inranet ?  "intranet_claims" : "claims";
                api = "claims";
                title = $i18n.t('module.claim');
                saveOperation = securityStore.authorities.SAVE_CLAIM;
                updateOperation = securityStore.authorities.UPDATE_CLAIM;
                deleteOperation = securityStore.authorities.DELETE_CLAIM;
                break;
            case 'ADMIN_REQUEST':
                rootPath = inranet ?  "intranet_admin_requests" : "admin_requests";
                api = "adminRequests";
                title = $i18n.t('module.admin_request');
                saveOperation = securityStore.authorities.SAVE_ADMIN_REQUEST;
                updateOperation = securityStore.authorities.UPDATE_ADMIN_REQUEST;
                deleteOperation = securityStore.authorities.DELETE_ADMIN_REQUEST;
                break;
        }


        return {
            rootPath,
            api,
            title,
            saveOperation,
            updateOperation,
            deleteOperation,
        }
    }

    function download(api, id, fileName) {
        axios.get(`/${api}/download/${id}`, {responseType: "blob"}).then(response => {
            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.click();
            // Revoke the temporary URL to free up memory
            URL.revokeObjectURL(url);
        });
    }

    function exportPdf(url) {
        axios.get(url, {responseType: "blob"}).then((response) => {
            const blob = response.data;
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            //this.objectURL = link.href;
            window.open(link, "_blank");
        });
    }

    function isTwoTest(operator) {
        switch (operator) {
            case "between":
                return true;
            case "betweenLeftSideEqualTo":
                return true;
            case "betweenRightSideEqualTo":
                return true;
            case "betweenBothSideEqualTo":
                return true;
            default:
                return false;
        }
    }

    const {paySectionPositions} = useSharedSelectData();

    function getPaySectionPosition(index) {
        return paySectionPositions[index];
    }

    function translateMonth(month, with_year) {
        if (month) {
            if (month.length === 4) {
                return ("Année " + month).toUpperCase();
            }
            if (with_year) {
                return moment(month).locale("fr").format("MMMM YYYY").toUpperCase();
            }
            return moment(month).locale("fr").format("MMMM").toUpperCase();
        }
        return '';
    }


    function getDataSelectName(type, dataSelectModules) {
        let r = '';
        dataSelectModules.forEach(m => {
            m.children.forEach(sb => {
                sb.children.forEach(d => {
                    if (d.id === type) {
                        r = `${$i18n.t(`data_select.module.${m.id}`)} --> ${$i18n.t(`data_select.module.sub.${sb.id}`)} --> ${$i18n.t(`data_select.${d.id}`)}`;
                    }
                });
            })
        });
        return r;
    }

    function getTrainingRequestPeriodName(request) {
        if (request.period === 'MONTHLY') {
            return $i18n.t(`common.${request.periodMonth}`);
        } else if (request.period === 'QUARTERLY') {
            return $i18n.t(`common.QUARTERLY_${request.periodQuarterlyOrHalfYearly}`);
        } else if (request.period === 'HALF_YEARLY') {
            return $i18n.t(`common.HALF_YEARLY_${request.periodQuarterlyOrHalfYearly}`);
        } else if (request.period === 'SPECIFIC') {
            return `${$i18n.t('common.from')}: ${formatedDate(request.periodStart)} ` + `${$i18n.t('common.to')}: ${formatedDate(request.periodEnd)}`;
        }

    }

    function copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(function () {
            console.log('Text copied to clipboard');
        }).catch(function (error) {
            console.error('Error copying text: ', error);
        });
    }

    function transformFilterValues(filter) {
        const transformedFilter = {...filter};
        Object.keys(transformedFilter).forEach(key => {
            if (Array.isArray(transformedFilter[key])) {
                transformedFilter[key] = transformedFilter[key].toString(); // Convert array to comma-separated string
            }
        });
        return transformedFilter;
    }

    function getRestState(item) {
        switch (item.validationStatus.status) {
            case 'WAITING':
            case 'IN_PROGRESS':
            case 'PENDING':
                return {state: 'WAITING', color: 'orange'};
            case 'REFUSE':
                return {state: 'CLOSED', color: 'red'};
            case 'ACCEPT':
                return item.rest > 0 ? {state: 'IN_PROGRESS', color: 'teal'} : {state: 'CLOSED', color: 'red'};
        }
    }

    function formatedEvaluationCycle(item) {
        switch (item.cycle) {
            case 'MONTHLY':
                return `${$i18n.t(`common.${item.cycleMonth}`)} ${item.cycleYear}`;
            case 'QUARTERLY':
                return `${$i18n.t(`common.QUARTERLY_${item.cycleQuarterlyOrHalfYearly}`)} ${item.cycleYear}`;
            case 'HALF_YEARLY':
                return `${$i18n.t(`common.HALF_YEARLY_${item.cycleQuarterlyOrHalfYearly}`)} ${item.cycleYear}`;
            case 'YEARLY':
                return `${$i18n.t('common.year')} ${item.cycleYear}`;
            case 'SPECIFIC':
                return $i18n.t('evaluation.SPECIFIC');
        }
    }

    function getStatusColor(status) {
        switch (status) {
            case 'RECRUITMENT_VALIDATION':
                return 'grey';
            case 'RECRUITMENT_WAITING':
                return 'orange';
            case 'RECRUITMENT_SOURCING':
                return 'cyan';
            case 'RECRUITMENT_PLANNING':
                return 'purple';
            case 'RECRUITMENT_EVALUATION':
                return 'green';
            case 'RECRUITMENT_PENDING':
                return 'grey';
            case 'RECRUITMENT_CLOSED':
                return 'grey darken-2';


            case 'BOARDING_TO_TREAT':
                return 'orange';
            case 'BOARDING_IN_PROGRESS':
                return 'blue';
            case 'BOARDING_PENDING':
                return '';
            case 'BOARDING_FINISHED':
                return 'teal';


            case 'CONTRAT_WITHOUT':
                return 'blue-grey';
            case 'CONTRAT_ACTIVE':
                return 'blue ligthen-2';
            case 'CONTRAT_PENDING':
                return 'amber';
            case 'CONTRAT_VALIDATED':
                return 'teal';
            case 'CONTRAT_REJECTED':
                return 'red';
            case 'CONTRAT_RENEWED':
                return 'cyan';
            case 'CONTRAT_UNPROCESSED':
                return 'grey darken-2';
        }
    }

    return {
        getStatusColor,
        formatedEvaluationCycle,
        getRestState,
        transformFilterValues,
        getTrainingRequestPeriodName,
        getDataSelectName,
        translateMonth,
        formatedTime,
        getPaySectionPosition,
        isTwoTest,
        rowColor,
        itemClick,
        getBack,
        formatedMonth,
        formatedDate,
        formatedDateTime,
        priceFormat,
        logout,
        getDialogToolbar,
        getClaimParamsByType,
        download,
        exportPdf,
        copyToClipboard
    };
}
